import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { adminRoutes } from '../../constants';
import { map, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  selector: 'gstar-user-page',
  templateUrl: 'users-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersPageComponent {
  private translateService = inject(TranslateService);
  private readonly router = inject(Router);
  readonly activatedRoute = inject(ActivatedRoute);

  public indexTab$!: Observable<number>;

  public userTabs: { route: string; label: string }[] = [
    {
      label: this.translateService.instant(
        'admin.dashboard.internalUserTitleShort'
      ),
      route: adminRoutes.users.internalUsers,
    },
    {
      label: this.translateService.instant(
        'admin.dashboard.externalUserTitleShort'
      ),
      route: adminRoutes.users.externalUsers,
    },
  ];

  constructor() {
    this.indexTab$ = this.activatedRoute.firstChild!.url.pipe(
      takeUntilDestroyed(),
      map(url =>
        this.userTabs.findIndex(item =>
          url.find(segment => item.route === segment.path)
        )
      )
    );
  }

  tabChange(index: number): void {
    this.router.navigate([
      adminRoutes.root,
      adminRoutes.users.root,
      index === 0
        ? adminRoutes.users.internalUsers
        : adminRoutes.users.externalUsers,
    ]);
  }
}
